import { render, staticRenderFns } from "./TheLogotype.vue?vue&type=template&id=f9047fee&"
import script from "./TheLogotype.vue?vue&type=script&lang=js&"
export * from "./TheLogotype.vue?vue&type=script&lang=js&"
import style0 from "./TheLogotype.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports